import { useState, useEffect } from "react";
import Banner from "./Hero/hero";
import CarouselWithProductList from "./Collections/collections";
import CarouselWithContent from "./Trends/trends";
import WhyChooseUs from "./AboutUs/aboutUs";
import Blog from "./Blogs/blogs";
import Testimonials from "./Testimonials/testimonials";
import MultipleImagesWithContent from "./OurFounder/founder";
import { API_ENDPOINTS,fetchHomeData } from "../../Providers/homeProvider";

const HomePageApi = () => {
  const [bannerData, setBannerData] = useState(null);
  const [carouselData, setCarouselData] = useState([]); // Ensure it's an array
  const [sections, setSections] = useState([]);
  const [aboutData,setAboutData] =useState([]);
  const [testimonialsData,setTestimonialsData] =useState([]);
  const [collectionData, setCollectionData] = useState([]);
  const [blogsData,setBlogsData] = useState([]);
 


  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const data = await fetchHomeData();
    if (data  && data.length > 2) {
      [data[0], data[1], data[2]] = [data[1], data[2], data[0]];
      setSections(data);

      // Extract Banner Section
      const bannerSection = data.find((section) => section.structure_type === "banner");
      if (bannerSection) {
        setBannerData(bannerSection.data);
      }

      // Extract Carousel Section
      const carouselSection = data.find((section) => section.structure_type === "carousel_with_content");
      if (carouselSection && Array.isArray(carouselSection.data)) {
        console.log("Caorusel with content------",carouselSection.data);
        setCarouselData(carouselSection.data);
      }
      const aboutSection = data.find((section) => section.structure_type === "why_choose_us");
      if (aboutSection && Array.isArray(aboutSection.data)) {
        setAboutData(aboutSection.data);
      }
      const testimonialsSection = data.find((section) => section.structure_type === "carousel_with_testimonial");
      if (testimonialsSection && Array.isArray(testimonialsSection.data)) {
        setTestimonialsData(testimonialsSection.data);
      }
      const founderSection = data.find((section) => section.structure_type === "multiple_images_with_content");
      if (founderSection && Array.isArray(founderSection.data)) {
        setTestimonialsData(founderSection.data);
      }
      const collectionSection = data.find((section) => section.structure_type === "carousel_with_product_list");
      if (collectionSection && Array.isArray(collectionSection.data)) {
        setCollectionData(collectionSection.data);
      }
      const blogsSection = data.find((section) => section.structure_type === "blog");
      if (blogsSection && Array.isArray(blogsSection.data)) {
        setBlogsData(blogsSection.data);
      }
      
    }
  };

  return (
    <div className="home-container">
      {sections.map((section, index) => {
        switch (section.structure_type) {
          case "banner":
            // console.log("Banner data only------", section.data);
            return <Banner key={index} data={section.data} bannerData={bannerData} />;
          case "carousel_with_product_list":
            console.log("carousel_with_product_list data only------", section.data);

            return <CarouselWithProductList key={index} data={section.data} />;
          case "carousel_with_content":
            // console.log("carousel_with_content data only------", section.data);

            return <CarouselWithContent key={index} data={section.data} carouselData={carouselData} />;
          case "why_choose_us":
            return <WhyChooseUs key={index} data={section.features} aboutData={aboutData}/>;
          case "blog":
            return <Blog key={index} data={section.data} />;
          case "carousel_with_testimonial":
            return <Testimonials key={index} data={section.data} testimonialsData={testimonialsData}/>;
          case "multiple_images_with_content":
            return <MultipleImagesWithContent key={index} data={section.data}  />;
          default:
            return null;
        }
      })}
    </div>
  );
};

export default HomePageApi;
